const safe2HTML = (text?: string) => {
    // convert backend safe html to html
    let e = text;
    const textarea = document.createElement('textarea');
    textarea.style.cssText = 'opacity: 0; z-index:-10000;';
    document.body.appendChild(textarea);
    if (e && e.length > 0)
        while (e.includes('&amp;') || e.includes('&lt;') || e.includes('&quot;')) {
            textarea.innerHTML = e;
            e = textarea.value;
        }
    textarea.remove();
    return e ? e : '';
};

export const extractTitle = (e = '', parse = true, replace = true) => {
    // parse: render inner text instead of html , replace: replace pattern with question title
    const totalRegex = /@\[[^@\[]+?()\]\([^@\[]+?()\)/;
    const textRegex = /[^@\[]+?(?=\]\([^@\[]+\))/;
    if (e) {
        let item;
        while ((item = totalRegex.exec(e))) {
            const title = item[0];
            const qTitle = textRegex.exec(title);
            if (qTitle) {
                e = e.replace(title, replace ? '{ ' + qTitle[0] + ' }' : ' ');
            }
        }
    }
    e = safe2HTML(e);
    if (parse) {
        const textarea = document.createElement('div');
        textarea.style.cssText = 'opacity: 0; z-index:-10000;';
        document.body.appendChild(textarea);
        textarea.innerHTML = e;
        e = textarea.innerText.replace(/\r?\n|\r/g, ' ');
        textarea.remove();
    } else e = e.replace(/<[^/>][^>]*><\/[^>]+>/g, '<p>&nbsp;</p>');
    return e;
};

export const extractFileName = (e = '') => {
    const nameRegex = /[^/\\&\?]+\.\w{3,4}(?=([\?&].*$|$))/g;
    if (e) {
        const item = nameRegex.exec(e);
        if (item && item.length) e = item[0];
    }
    return e;
};

export function IsJsonString(str: string) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const prsNum2Eng = function (str: string) {
    // convert ۰-۹ numbers to 0-9 in a text
    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
        arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    if (typeof str === 'string') {
        for (let i = 0; i < 10; i++) {
            str = str.replace(persianNumbers[i], i.toString()).replace(arabicNumbers[i], i.toString());
        }
    }
    return str;
};
